import { Component, QueryList, ViewChildren } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ProjetosService } from '../projetos.service';
import { LoginService } from '../login.service';
import { UtilsService } from '../utils.service';

@Component({
  selector: 'app-projetos',
  templateUrl: './projetos.component.html',
  styleUrls: ['./projetos.component.css']
})
export class ProjetosComponent {

  public pop:boolean = false;
  public projetos: Array<Object> = [];
  public progressBar:boolean = true;
  public filtro:string = "";
  public tipoProjeto: Object = {
    "TCC": "TCC",
    "MONOGRAFIA": "MONOGRAFIA",
    "MESTRADO": "MESTRADO",
    "DOUTORADO": "DOUTORADO",
    "ARTIGO": "ARTIGO",
    "POSTER": "POSTER",
    "RELATORIO": "RELATÓRIO",
    "PROJETO_PESQUISA": "PROJETO DE PESQUISA",
    "PROJETO_RECURSOS": "PROJETO DE RECURSOS"
}
 
  constructor(private projetoServ:ProjetosService,
              private loginServ: LoginService,
              public route: ActivatedRoute,
              public router: Router) {}

  @ViewChildren('allTheseThings') things: QueryList<any>;

  ngOnInit () {}

  ngAfterViewInit() {
    this.listarProjetos();
    this.things.changes.subscribe(t => {
        this.pop = true;
    })
  }

  opcoes(item) {
    if (item.opcoes == false)
      item.opcoes = true;
    else item.opcoes = false;
  }

  encerrarProjeto($motivo, item) {
    if ($motivo == "") {
      UtilsService.alerta("É necessário escrever o motivo de encerramento.", "erro");
    } else {
      let proj = {idUsuario: this.loginServ.getUsuario("id"), motivo: $motivo};
      this.projetoServ.encerrarProjeto(item.id, proj).subscribe((resp) => {
        try {
          if (resp["status"] == "CONCLUIDO") {
            UtilsService.alerta("Projeto encerrado com sucesso.", "sucesso");
          } else {
            UtilsService.alerta("Houve um problema ao encerrar o projeto, favor tentar mais tarde.", "erro");
          }
          this.listarProjetos();
        } catch(e) {

        }
      }, resp => {
        UtilsService.alerta(resp.error.message, 'erro');
      });
    }
  }

  editarProjeto(projeto:any) {
    if (projeto.userAdmin == false) {
      UtilsService.alerta('Você não é o orientador desse projeto para excluir!', 'erro');
      return;  
    }
    this.projetoServ.setProjeto(projeto);
    this.router.navigate(['/cadastro-projeto/', projeto.id, projeto.descricao]);
  }

  excluirProjeto(projeto:any) {
    if (projeto.userAdmin == false) {
      UtilsService.alerta('Você não é o orientador desse projeto para excluir!', 'erro');
      return;  
    }
    UtilsService.confirmacao('Atenção', 'Deseja mesmo excluir esse projeto?').then((option) => {
      if (option.value == true) {
        this.projetoServ.excluirProjeto(projeto.id).subscribe((resp) => {
          this.listarProjetos();
        });
      }
    })
  }

  filtrar($event) {
    this.filtro = String($event).trim();
  }

  filtroLista(items) {
    let itemsFiltrados:any = [];

    for (let idx in items) {
      if (this.filtro !== '' && this.filtro !== items[idx]["status"]) continue;
      
      itemsFiltrados.push(items[idx]);
    }

    return itemsFiltrados;
  }

  listarProjetos() {
    this.projetos = [];
    this.progressBar = true;
    this.projetoServ.listarProjetos().subscribe((resp) => {
      this.progressBar = false;

      for (let proj in resp)  {
        resp[proj].opcoes = false;

        resp[proj]["tipoProjetoDescricao"] = this.tipoProjeto[resp[proj]["tipoProjeto"]];

        resp[proj].percentualConclusao = parseInt((resp[proj].percentualConclusao !== null ? resp[proj].percentualConclusao : 0));
        this.projetos.push(resp[proj]);
      }

      //eval("M.Dropdown.init(document.querySelectorAll('.dropdown-trigger'), {})");

      /*
      setTimeout(function() {
        eval("M.Dropdown.init(document.querySelectorAll('.dropdown-trigger'), {})");
      }, 1000); 
      */
    }, resp => {
      UtilsService.alerta(resp.error.message, 'erro');
    });
  }

}